export const SURVEY_STATUS_ARCHIVED = 'archived';
export const SURVEY_STATUS_CLOSED = 'closed';
export const SURVEY_STATUS_DRAFT = 'draft';
export const SURVEY_STATUS_OPEN = 'open';
export const SURVEY_STATUS_PAUSED = 'paused';
